import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const OptionContainer = styled.div`
  display: inline-flex;
`;
